function filterOptions({ state, input, services }) {
  state.set(`${input.field}.query`, input.query)
  let field = state.get(input.field)
  let filteredOptions = null
  if (field.query && field.query.length > 0) {
    filteredOptions = field.options.reduce((acc, option, index) => {
      let { value, i18nKey, i18nPath } = option
      if (i18nKey || i18nPath) {
        let path = i18nPath || `bus-shared.aggregation.data.key.${i18nKey}`
        value = services.client.translate(path)
      }
      if (
        value &&
        value.toLowerCase().indexOf(field.query.toLowerCase()) !== -1
      ) {
        acc.push({ ...option, index })
      }
      return acc
    }, [])
  }
  state.set(`${input.field}.filteredOptions`, filteredOptions)
}

export default filterOptions



// WEBPACK FOOTER //
// ./src/modules/client/actions/filterOptions.js